import { render, staticRenderFns } from "./addsupervisior.vue?vue&type=template&id=b223ca00"
import script from "./addsupervisior.js?vue&type=script&lang=js&external"
export * from "./addsupervisior.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports